export default __webpack_public_path__ + "static/media/pantry1-afterH-1920w.6a45128b.webp";